import { createAction } from 'redux-act';

const PREFIX = `GIFTS`;

export const fetchGiftsWithStoredFilters = createAction(`${PREFIX}/DISPATCH_FILTERS`);
